import {Controller} from '@stubhub/react-store-provider';

import {
  hideTicketBisPriceSelector,
  isRedirectModalEnabledSelector,
  priceIncludeFeesSelector,
  showVenueCountryFlagSelector,
} from '../../store/gsConfig/FF/selectors';
import {userIpCountryCodeSelector} from '../../store/user/selectors';

const controller = new Controller({
  namespace: 'event-item',
  mapStateToProps: (state) => {
    const deviceState = state.device || {};

    return {
      deviceType: deviceState.type,
      isRedirectModalEnabled: isRedirectModalEnabledSelector(state),
      userCountryCode: userIpCountryCodeSelector(state),
      isPriceIncludeFees: priceIncludeFeesSelector(state),
      hideTicketBisPrice: hideTicketBisPriceSelector(state),
      showVenueCountryFlag: showVenueCountryFlagSelector(state),
    };
  },
});

export default controller;
